import { render, staticRenderFns } from "./Massage.vue?vue&type=template&id=81afc02e&scoped=true&"
import script from "./Massage.vue?vue&type=script&lang=js&"
export * from "./Massage.vue?vue&type=script&lang=js&"
import style0 from "./Massage.vue?vue&type=style&index=0&id=81afc02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81afc02e",
  null
  
)

export default component.exports